import { RouteHelpers } from '@/mixins';
import { EditReferences } from '@/types';

const EditReferencesView = () => import(/* webpackChunkName: "edit-references" */ '@/views/EditReferences.vue');

export const EditReferencesRoutes = [
  {
    ...EditReferences.EditReferences,
    component: EditReferencesView,
    beforeEnter: (to: any, from: any, next: any) =>
      // tslint:disable-next-line:max-line-length
      RouteHelpers.beforeEnterCheckRouteParamAsNumeric(to, from, next, ['sourceDocumentTypeId', 'sourceDocumentId']),
    meta: {
      title: 'Edit References'
    }
  },
  {
    ...EditReferences.Base,
    component: EditReferencesView,
    meta: {
      title: 'Edit References'
    }
  }
];
